import "./Billing.css";
import { useState } from "react";
import {
  FaCircle,
  FaPrint,
  FaFilePdf,
  FaPhoneSquareAlt,
  FaTrash,
} from "react-icons/fa";
import { LiaAngleDoubleRightSolid } from "react-icons/lia";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { IoIosContact } from "react-icons/io";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import Form from "react-bootstrap/Form";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { Container, Row, Col } from "react-bootstrap";

// Mock data (replace with props or API in production)
const customers = [
  { id: 1, phone: "9876543210", name: "John Doe" },
  { id: 2, phone: "8765432109", name: "Jane Smith" },
  { id: 3, phone: "7654321098", name: "Michael Johnson" },
];

const categories = [
  { id: 1, name: "Xerox" },
  { id: 2, name: "Color Xerox" },
  { id: 3, name: "Print Out" },
];

const paymentModes = ["Cash", "Gpay"];

export default function BillingTable() {
  const [order, setOrder] = useState({
    id: "111-222",
    customer_id: 1,
    discount: 20,
    notes: "short description1",
    amount_received: 0,
    amount_received_through: "Cash",
    balance: 0,
  });

  const [items, setItems] = useState([
    { category_id: 1, qty: 1, price: 150 },
    { category_id: 2, qty: 2, price: 50 },
  ]);

  const selectedCustomer = customers.find((c) => c.id === order.customer_id);

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = field === "category_id" ? parseInt(value) : parseFloat(value);
    setItems(updatedItems);
  };

  const addItem = () => {
    setItems([...items, { category_id: categories[0].id, qty: 1, price: 0 }]);
  };

  const deleteItem = (indexToDelete) => {
    setItems(items.filter((_, index) => index !== indexToDelete));
  };

  const getItemTotal = (item) => item.qty * item.price;

  const subTotal = items.reduce((sum, item) => sum + getItemTotal(item), 0);
  const discountAmt = (subTotal * order.discount) / 100;
  const totalAmount = subTotal - discountAmt;
  const balance = totalAmount - order.amount_received;

  const handleAmountChange = (field, value) => {
    setOrder((prev) => ({
      ...prev,
      [field]: field === "amount_received" ? parseFloat(value) || 0 : value,
    }));
  };

  const printInvoice = () => {
    window.print();
  };

  return (
    <div className="page-content container">
      <div className="page-header text-blue-d2 d-flex justify-content-between align-items-center">
        <h1 className="page-title text-secondary-d1">
          Invoice
          <small className="page-info">
            <LiaAngleDoubleRightSolid />
            ID: #{order.id}
          </small>
        </h1>
        <div className="page-tools">
          <div className="action-buttons">
            <button className="btn bg-white btn-light mx-1 text-95" onClick={printInvoice}>
              <FaPrint className="mr-1 text-primary-m1 text-120 w-2" />
              Print
            </button>
            <button className="btn bg-white btn-light mx-1 text-95">
              <FaFilePdf className="mr-1 text-danger-m1 w-2" />
              Export
            </button>
          </div>
        </div>
      </div>

      <div className="container px-0">
        <div className="row mt-4">
          <div className="col-12">
            <Row className="brc-default-l1 mx-n1 mb-4">
              <hr className="w-100" />
            </Row>

            <Row>
              <Col sm={6}>
                <div>
                  <IoIosContact size={25} className="align-middle" />
                  <span className="text-600 text-110 text-blue align-middle">
                    {selectedCustomer?.name}
                  </span>
                </div>
                <div className="text-grey-m2">
                  <div className="my-1">
                    <FaPhoneSquareAlt size={23} />{" "}
                    <b className="text-600"> {selectedCustomer?.phone}</b>
                  </div>
                  <div className="my-1">
                    Credit <Switch /> Cash
                  </div>
                </div>
              </Col>
              <Col sm={6} className="d-flex justify-content-end">
                <div className="text-grey-m2">
                  <div className="mt-1 mb-2 text-secondary-m1 text-600 text-125">Invoice</div>
                  <div className="my-2">
                    <FaCircle className="text-blue-m2 text-xs mr-1" />{" "}
                    <span className="text-600 text-90">ID:</span> #{order.id}
                  </div>
                  <div className="my-2">
                    <FaCircle className="text-blue-m2 text-xs mr-1" />{" "}
                    <span className="text-600 text-90">Issue Date:</span> {new Date().toDateString()}
                  </div>
                </div>
              </Col>
            </Row>

            {/* Items Header */}
            <div className="mt-4">
              <div className="row bgc-default-tp1 py-2 text-white text-600">
                <div className="d-none d-sm-block col-1">#</div>
                <div className="col-3">Description</div>
                <div className="d-none d-sm-block col-2">Qty</div>
                <div className="d-none d-sm-block col-2">Unit Price</div>
                <div className="col-3">Amount</div>
                <div className="col-1 text-center">Del</div>
              </div>

              {/* Item Rows */}
              <div className="text-95 text-secondary-d3">
                {items.map((item, index) => (
                  <div key={index} className="row py-2 align-items-center">
                    <div className="d-none d-sm-block col-1">{index + 1}</div>

                    <div className="col-3">
                      <Form.Select
                        size="sm"
                        value={item.category_id}
                        onChange={(e) => handleItemChange(index, "category_id", e.target.value)}
                      >
                        {categories.map((cat) => (
                          <option key={cat.id} value={cat.id}>{cat.name}</option>
                        ))}
                      </Form.Select>
                    </div>

                    <div className="d-none d-sm-block col-2">
                      <TextField
                        size="small"
                        type="number"
                        value={item.qty}
                        onChange={(e) => handleItemChange(index, "qty", e.target.value)}
                      />
                    </div>

                    <div className="d-none d-sm-block col-2">
                      <FormControl fullWidth>
                        <OutlinedInput
                          size="small"
                          type="number"
                          value={item.price}
                          onChange={(e) => handleItemChange(index, "price", e.target.value)}
                          startAdornment={<InputAdornment position="start"><FaIndianRupeeSign /></InputAdornment>}
                        />
                      </FormControl>
                    </div>

                    <div className="col-3">
                      <OutlinedInput
                        size="small"
                        value={getItemTotal(item)}
                        startAdornment={<InputAdornment position="start"><FaIndianRupeeSign /></InputAdornment>}
                        disabled
                      />
                    </div>

                    <div className="col-1 text-center">
                      <Button variant="text" size="small" onClick={() => deleteItem(index)}>
                        <FaTrash color="red" />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>

              <Button variant="outlined" className="my-3" onClick={addItem}>+ Add Item</Button>

              {/* Notes and Summary */}
              <div className="row mt-3">
                <div className="col-lg-7">
                  <Form.Group className="mb-3">
                    <Form.Label>Notes</Form.Label>
                    <Form.Control as="textarea" rows={3} value={order.notes} readOnly />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Amount Received</Form.Label>
                    <Form.Control
                      type="number"
                      value={order.amount_received}
                      onChange={(e) => handleAmountChange("amount_received", e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Payment Mode</Form.Label>
                    <Form.Select
                      value={order.amount_received_through}
                      onChange={(e) => handleAmountChange("amount_received_through", e.target.value)}
                    >
                      {paymentModes.map((mode, i) => (
                        <option key={i} value={mode}>{mode}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="col-12 col-sm-5 text-grey">
                  <div className="row my-2">
                    <div className="col-7 text-right">SubTotal</div>
                    <div className="col-5"><FaIndianRupeeSign />{subTotal.toFixed(2)}</div>
                  </div>
                  <div className="row my-2">
                    <div className="col-7 text-right">Discount ({order.discount}%)</div>
                    <div className="col-5"><FaIndianRupeeSign />{discountAmt.toFixed(2)}</div>
                  </div>
                  <div className="row my-2 text-success p-2">
                    <div className="col-7 text-right"><h5>Total Amount</h5></div>
                    <div className="col-5"><h5><FaIndianRupeeSign />{totalAmount.toFixed(2)}</h5></div>
                  </div>
                  <div className="row my-2 text-danger p-2">
                    <div className="col-7 text-right"><strong>Balance</strong></div>
                    <div className="col-5"><strong><FaIndianRupeeSign />{balance.toFixed(2)}</strong></div>
                  </div>
                </div>
              </div>

              <hr />
              <div className="float-lg-right">
                <Button variant="contained">Submit</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
